import {Inject, Injectable} from "ng-metadata/core";

@Injectable()
export class TranslationService{
    private translationTable;
    constructor(@Inject('$translate') private $translate : ng.translate.ITranslateService,
                @Inject('$rootScope') $rootScope: ng.IRootScopeService){
        $rootScope.$on('$translateChangeSuccess', ()=>{
            this.translationTable = this.$translate.getTranslationTable();
        });
    }

    public translateInstantWithDefault(code : string, defaultValue : string, interpolateParams?: any, interpolationId?: string){
        if (!this.translationTable || !this.translationTable[code]){
            return defaultValue;
        }
        else{
            return this.$translate.instant(code, interpolateParams, interpolationId);
        }
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/translate/translation.service.ts